import HttpService from './httpService';
import config from '../../config';

class EnvioMailApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async consultaGrupos({ headquarter }) {
    return this.get('consultaGrupo', { params: { headquarter } });
  }

  async consultaAlumnosFiltrados({ headquarter, listadoGrupos, listadoCentros }) {
    return this.get('consultaAlumnosFiltrados', {
      params: { headquarter, listadoGrupos, listadoCentros },
    });
  }

  async enviarCorreoMasivo(data, { empresaId }) {
    return this.post('enviarCorreoMasivo', data, { params: { empresaId } });
  }

  async getRemesas() {
    return this.get('getRemesas');
  }

  async getEnviosByRemesa({ headquarter, idRemesa }) {
    return this.get('getEnviosByRemesa', { params: { headquarter, idRemesa } });
  }
}

const envioMailService = new EnvioMailApiService(config.REACT_APP_NODE_API);

export default envioMailService;
